import moment, { Moment } from "moment";

export const formatDateTime = (date: Moment): string[] => {
  const formattedDate: string = moment(date).format("LLL");
  const dateArray: string[] = formattedDate.split(" ");
  return dateArray;
};
